import OperationsPageShell from '../components/OperationsPageShell';

const alerts = [
  { type: 'Overdue Order', severity: 'Critical', branch: 'Dar es Salaam', age: '12h', message: 'Order 12890 has exceeded SLA threshold.' },
  { type: 'Stalled Route', severity: 'Warning', branch: 'Mwanza', age: '6h', message: 'Route R-204 has not advanced in 4 hours.' },
  { type: 'Available Vehicle', severity: 'Info', branch: 'Arusha', age: '2h', message: '3 vehicles are available for dispatch.' },
];

const severityMap: Record<string, string> = {
  Critical: 'badge-light-danger',
  Warning: 'badge-light-warning',
  Info: 'badge-light-info',
};

const CriticalAlerts = () => (
  <OperationsPageShell
    title="Critical Alerts"
    subtitle="Operational alerts grouped by type, severity, and branch."
    action={
      <button type="button" className="uw-btn uw-btn-light uw-btn-sm btn btn-sm btn-light">
        ↻ Refresh
      </button>
    }
  >
    <div className="d-flex flex-wrap gap-2 mb-5">
      {['All', 'Overdue Order', 'Stalled Route', 'Pending Return'].map((chip) => (
        <button key={chip} type="button" className="uw-btn uw-btn-light uw-btn-sm btn btn-sm btn-light">
          {chip}
        </button>
      ))}
    </div>

    <div className="table-responsive">
      <table className="table align-middle gs-0 gy-3">
        <thead>
          <tr>
            <th>Type</th>
            <th>Severity</th>
            <th>Branch</th>
            <th>Age</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          {alerts.map((alert) => (
            <tr key={`${alert.type}-${alert.branch}`}>
              <td>{alert.type}</td>
              <td>
                <span className={`badge ${severityMap[alert.severity] || 'badge-light-secondary'}`}>
                  {alert.severity}
                </span>
              </td>
              <td>{alert.branch}</td>
              <td>{alert.age}</td>
              <td>{alert.message}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </OperationsPageShell>
);

export default CriticalAlerts;
